export type PermissionKey =
    | 'impersonation'
    | 'mpd_impersonation'
    | 'staffing_dashboard'
    | 'widget_mail'
    | 'widget_calendar'
    | 'widget_provider_data'
    | 'widget_openings'
    | 'widget_service_request'
    | 'epr_metrics_admin';

export class AccessControl {
    private readonly permissions: Permissions;

    constructor(_permissions?: Permissions) {
        this.permissions = _permissions ?? {};
    }

    canRead(feature: PermissionKey): boolean {
        if (this.permissions[feature]) {
            return this.permissions[feature].read;
        }
        else return false;
    }
    canWrite(feature: PermissionKey): boolean {
        if (this.permissions[feature]) {
            return this.permissions[feature].write;
        }
        else return false;
    }
}
export interface Permissions {
    [key: string]: Permission
}
export interface Permission {
    read: boolean,
    write: boolean
}

export interface AccessControlRes {
    title: string,
    read: boolean,
    write: boolean
}